export const TAG_SIZE = 44;
export const TAG_SIZE_NON_ADMIN = 16;
export const TAG_SIZE_NON_ADMIN_EXPANDED = 32;
export const TAG_OFFSET = 0;
export const PRODUCT_TAG_WITH_MODAL_WIDTH = 296;
export const PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG = 16;
export const PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX = 24;
export const PRODUCT_TAGGING_REVEAL_TRANSITION_ICONS =
    'opacity 350ms ease-in 0s, visibility 350ms ease-in 0s';
